import { AnalyticEventCategory, AnalyticEventType } from '../../../../shared/entity_datas/EntityDatas.ts';
import { CA } from './Analytics.ts';
function sendRushAdAnalytic(type, source, variant) {
    const eventData = {
        type: type,
        category: AnalyticEventCategory.AdsPerformance,
        dimensions: {
            source: source,
            variant: variant
        }
    };
    void CA.sendAnalyticEvent(eventData);
}
export function sendRushAdImpression(source, variant) {
    sendRushAdAnalytic(AnalyticEventType.RushAdImpression, source, variant);
}
export function sendRushAdClicked(source, variant) {
    sendRushAdAnalytic(AnalyticEventType.RushAdClicked, source, variant);
}
